import { render, staticRenderFns } from "./Template7.vue?vue&type=template&id=50cc86f8&scoped=true&"
import script from "./Template7.vue?vue&type=script&lang=js&"
export * from "./Template7.vue?vue&type=script&lang=js&"
import style0 from "./Template7.vue?vue&type=style&index=0&id=50cc86f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc86f8",
  null
  
)

export default component.exports